<template>
    <b-modal id="advisorChannelModal" class="channel-modal" v-model="showAdvisorChannelModal" size="medium" title="advisor channel modal"  hide-footer ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>

        <div class="channel-section channel-modal-popup">
        	<div class="header">
                <div class="left-heading">
                    <span class="icon-channel"></span>
                    <span class="title">Channels</span>
                </div>
				 <button class="btn_close" aria-label="close" @click="cancelAdvisoryChannel">
                     <span class="ic-close"></span>
                  </button>
            </div>
        	<div class="header note_head">
                <div class="left-heading">
                    <span class="ico-notes"></span>
					 <div class="channel_name">
					 <span class="fas fa-users"></span>
                     <span class="title">{{channelName}}</span>
					</div>
                </div>
            </div>

    		<div class="channel-content-section">
    			<div class="channel-mid-column channel-width" style="width: 100% !important;">
    				<div class="msg_row_section">
    					<div class="msg_section_inner">
    						<div class="chat-message" v-for="message in messages" v-if="messages.length > 0">
    							<div class="message-avatar-default">
    								<span class="icon-user"></span>
    							</div>
    							<div class="message-details">
    								<div class="message-author-name">
    									<span class="message-author">{{message.name}}</span>
    									<span class="message-time" v-if="showMessageTimestamp"> {{message.date}}</span>
                      <!--
                      <span class="job-tag tag_notification" v-if="showUrgentNotificationsTag && message.type && message.type === 'Urgent Notification'"> {{message.type}}</span>
                      <span class="job-tag tag_recommendation" v-if="message.type && message.type === 'Recommendation'"> {{message.type}}</span>
                      -->
                      <b-dropdown right variant="primary" v-if="message.uuid === userId && canShowModify && canSend"  class="fa fa-ellipsis-v more_action">
                        <b-dropdown-item href="#"  @click="openEditMessage(message)">Edit</b-dropdown-item>
                        <b-dropdown-item href="#"  @click="deleteMessage(message)">Remove</b-dropdown-item>
                      </b-dropdown>
    								</div>
    								<div class="message">
    									<div class="message-content">
    										{{message.text}}
    									</div>
    								    <div class="message-edit" :id="message['.key']" style="display: none;">
    									  <textarea class="message-in" placeholder="type your notes and click save" aria-label="edit message" v-model.trim="editMessage"></textarea>
    									  <div class="btn-container">
    										  <button type="submit" value="save" class="send-btn btn" @click="saveEditMessage(message)">save</button>
    										  <button type="submit" value="cancel" class="send-btn btn" @click="cancelEditMessage(message)">cancel</button>
    									   </div>
    								    </div>
    								</div>
    							</div>

                  <div class="msg_sec">

					        </div>

    						</div>
    					</div>
    				</div>
            <div class="channel_participants">
              <span>{{participants}}</span>
            </div>
    				<div class="chat-message-form" v-if="canSend">

              <!--
    					<div class="channel-dropdown">
    					  <b-dropdown no-caret>
    						<template slot="button-content">
    						  <span class="icon icon-channel" v-if="messageType == 'Message'"></span>
                              <span class="icon icon-bell" v-if="messageType == 'Urgent Notification'"></span>
                              <span class="icon icon-bullhorn" v-if="messageType == 'Recommendation'"></span>
    						  <span class="icon-dropdown2"></span>
    						</template>
    						<b-dropdown-item @click="changeType('Recommendation')" :disabled="messageType === 'Recommendation'"><span class="icon icon-bullhorn"></span><span class="text">Recommendation</span></b-dropdown-item>
    						<b-dropdown-item @click="changeType('Urgent Notification')" :disabled="messageType === 'Urgent Notification'"><span class="icon icon-bell"></span><span class="text">Urgent Notification</span></b-dropdown-item>
    						<b-dropdown-item @click="changeType('Message')" :disabled="messageType === 'Message'"><span class="icon icon-channel"></span><span class="text">Message</span></b-dropdown-item>
    					  </b-dropdown>
    					</div>
            -->
    					<div class="field-section">
    						<textarea class="message-in" placeholder="type your notes" v-model.trim="sendMessage" aria-label="message box" v-on:keyup.enter="send"> </textarea>
    						<div class="right-section">
                  <!--
							     <span class="fa fa-paperclip" aria-hidden="true"></span>
                 -->
    							<button type="submit" value="send" class="send-btn btn" @click="send()"><span class="fa fa-paper-plane"></span></button>
    						</div>
    					</div>
    				</div>
    			</div>
    		</div>
		</div>
    </b-modal>
</template>

<script>
import '../../../assets/module/sass/channel/channel.scss'
import { mapState, mapActions } from 'vuex'
import { db } from '../../../firebase'
import { PACKAGE } from '../../../package_constants'
import { StorageFactory } from '../../../storageFactory'

export const localStore = StorageFactory(() => localStorage)

export default {
  name: 'advisor-channel',
  props: ['externalId', 'channelName'],
  data: () => {
    return {
      sendMessage: '',
      editMessage: '',
      messageType: 'Message',
      userRole: localStore.getItem('userrole'),
      userId: localStore.getItem('userid'),
      userName: localStore.getItem('userFullName'),
      messages: [],
      unread: [],
      allUnread: [],
      currentChannel: this.externalId,
      canShowModify: true,
      showAdvisorChannelModal: false,
      channelDetail: {}
    }
  },
  watch: {
    externalId (newExternalId) {
      this.currentChannel = newExternalId
    },
    messages () {
      setTimeout(() => {
        var msgSectionHeight = $('.msg_section_inner').innerHeight()
        $('.msg_row_section').scrollTop(msgSectionHeight)
      }, 100)
    },
    unread (newUnread) {
      this.loadUnreadForThisUser()
    }
  },
  async created () {
    this.currentChannel = this.externalId
    this.channelDetail = await this.loadChannelDetailByExternalId(this.externalId)
    this.$watch('currentChannel', (externalId) => {
      if (externalId) {
        this.$bindAsArray('messages', db.ref('channels/' + externalId + '/Messages'))
      }
    }, {
      immediate: true
    })
  },
  firebase: {
    messages: {
      source: db.ref('channels/' + this.currentChannel + '/Messages'),
      readyCallback: function () {
        this.loadIsChannelReady(true)
        // console.log('externalId:', this.currentChannel)
        // console.log('firebase ref', this.$firebaseRefs)
      },
      cancelCallback: function (e) {
        console.log('Could not get messages', e)
      }
    },
    unread: {
      source: db.ref('channels/' + this.currentChannel + '/unread/' + localStore.getItem('userid')),
      readyCallback: function () {
        this.initializeUnread()
        this.loadUnreadForThisUser()
      },
      cancelCallback: function (e) {
        console.log('Could not get unread for this user', e)
      }
    },
    allUnread: {
      source: db.ref('channels/' + this.currentChannel + '/unread'),
      readyCallback: function () {

      },
      cancelCallback: function (e) {
        console.log('Could not get all unread', e)
      }
    }
  },

  methods: {
    ...mapActions([
      'loadUserJwt',
      'loadUnreadValue',
      'loadIsChannelReady',
      'loadIsChannelWindowClosed',
      'loadChannelDetailByExternalId'
    ]),

    cancelAdvisoryChannel () {
      this.showAdvisorChannelModal = false
      this.errors = []
    },

    updateChannel (channel) {
      if (this.currentChannel !== channel.externalId) {
        this.messages = []
        this.currentChannel = channel.externalId
        this.externalId = channel.externalId
        console.log('firebase ref', this.$firebaseRefs)
        console.log('messages: ', this.messages)
      }
    },
    initializeUnread () {
      if (this.unread.length === 0) {
        // Create a new unread when user first joins the channel
        this.$firebaseRefs.unread.push({
          uuid: this.userId,
          status: true
        })
      }
    },
    loadUnreadForThisUser () {
      if (this.unread.length > 0) {
        var lastChild = this.unread[this.unread.length - 1]
        if (lastChild) {
          this.loadUnreadValue(lastChild.status)
        }
      }
    },
    openEditMessage (message) {
      this.canShowModify = false
      let key = message['.key']
      $('#' + key).show()
      this.editMessage = message.text
      setTimeout(() => {
        var msgSectionHeight = $('.msg_section_inner').innerHeight()
        $('.msg_row_section').scrollTop(msgSectionHeight)
      }, 100)
    },
    saveEditMessage (message) {
      this.canShowModify = true
      let key = message['.key']
      $('#' + key).hide()
      this.$firebaseRefs.messages.child(message['.key']).update({ text: this.editMessage })
      this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: 'Successfully saved the message!'
      })
      // after saving
      this.editMessage = ''
    },
    cancelEditMessage (message) {
      this.canShowModify = true
      let key = message['.key']
      $('#' + key).hide()
      this.editMessage = ''
    },
    deleteMessage (message) {
      if (message.uuid === this.userId) {
        this.$firebaseRefs.messages.child(message['.key']).remove()
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: 'Successfully deleted the message!'
        })
      } else {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: 'You do not have the permission to delete this message'
        })
      }
    },
    send () {
      if (this.sendMessage.length > 0) {
        let date = new Date()
        let dd = date.getDate()
        let mm = date.getMonth() + 1
        let yyyy = date.getFullYear()
        let hr = date.getHours()
        let mn = date.getMinutes()
        if (mn < 10) {
          mn = '0' + mn
        }
        const message = {
          name: this.userName,
          uuid: this.userId,
          text: this.sendMessage,
          date: mm + '/' + dd + '/' + yyyy + ' ' + hr + ':' + mn,
          type: this.messageType
        }
        this.$firebaseRefs.messages.push(message)
        this.updateAllUnread()
        this.sendMessage = ''

        setTimeout(() => {
          var msgSectionHeight = $('.msg_section_inner').innerHeight()
          $('.msg_row_section').scrollTop(msgSectionHeight)
        }, 100)
      }
    },
    updateAllUnread () {
      for (var i = 0; i < this.allUnread.length; i++) {
        if (this.allUnread[i]['.key'] && this.allUnread[i]['.key'] !== this.userId) {
          db.ref('channels/' + this.currentChannel + '/unread/' + this.allUnread[i]['.key']).push({
            uuid: this.allUnread[i]['.key'],
            status: true
          })
        }
      }
    },
    closeModalBox () {
      this.$root.$emit('bv::hide::modal', 'advisorChannelModal')
      this.$parent.isShowAdvisorChannel = false
    },
    changeType (type) {
      this.messageType = type
    }
  },
  computed: {
    ...mapState({
      'userJwt': state => state.channel.userJwt,
      'enabledFeatures': state => state.institution.enabledFeatures
    }),
    canSend () {
      let channelFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CHANNEL_CAN_SEND_FEATURE_ID]
      if (channelFeature) {
        return channelFeature.enabled
      }
      return true
    },
    showUrgentNotificationsTag () {
      let feature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CHANNEL_SHOW_URGENT_NOTIFICATIONS_TAG]
      if (feature) {
        return feature.enabled
      }
      return true
    },
    showMessageTimestamp () {
      let feature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CHANNEL_SHOW_MESSAGE_TIMESTAMP]
      if (feature) {
        return feature.enabled
      }
      return true
    },
    participants () {
      if (this.channelDetail && this.channelDetail.participants && this.channelDetail.participants.length > 0) {
        let advisors = '(' + this.channelDetail.participants[0].firstName + ' ' + this.channelDetail.participants[0].lastName
        if (this.channelDetail.participants.length > 1) {
          for (var i = 1; i < this.channelDetail.participants.length; i++) {
            advisors = advisors + ', ' + this.channelDetail.participants[i].firstName + ' ' + this.channelDetail.participants[i].lastName
          }
        }
        advisors = advisors + ' can see these messages)'
        return advisors
      }
      return ''
    }
  }

}
</script>

<style>
	.collapsed > .collapsed,
	:not(.collapsed) > .expand {
	  display: none;
	}

	@media (min-width: 500px) {
        .modal .modal-medium {
            max-width: 60% !important;
            width: 60% !important;
            min-width: 500px !important;
        }
    }

  .channel_participants {
    margin: 0px 10px 0px 10px;
  }
  .channel_participants span {
    color: #bbb;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/app/channel/components/AdvisorChannel.vue